import Games from "./Games";
export default Games;